import { refreshAuthentication } from './hub';
import { actionChannel, take, call, put, select } from 'redux-saga/effects';
import { push as replace } from 'redux-first-history';

import moment from 'moment';

const getCurrentRoute = (state) => state.router.location.pathname;

export function* callHUB(hubCall, credentialStore, payload, payload_2, payload_3, payload_4, payload_5) {
    yield put({
        type: 'CHECK_TOKENS',
        credentialStore,
        forceRefresh: false,
        silent: true,
    });

    // Continue when the check on the tokens has been completed
    while (true) {
        yield take('CHECK_TOKENS_COMPLETE');

        // Do the actual call to the HUB and return the response of the request
        const request = yield call(hubCall, credentialStore, payload, payload_2, payload_3, payload_4, payload_5);
        return request;
    }
}

export function* watchRefreshTokensRequests() {
    const requestsChannel = yield actionChannel('CHECK_TOKENS');

    while (true) {
        const { credentialStore, forceRefresh } = yield take(requestsChannel);
        yield call(checkAndRefreshAuthentication, credentialStore, forceRefresh);
    }
}

function hasTokenExpired(accessToken) {
    const tokenObject = JSON.parse(atob(accessToken.split('.')[1]));
    const expirationDate = moment(tokenObject.exp * 1000).utc();
    let isExpired = false;

    if (expirationDate <= moment().utc()) {
        isExpired = true;
    }
    return isExpired;
}

function* checkAndRefreshAuthentication(credentialStore, forceRefresh = false) {
    const tokens = yield credentialStore.getTokens();

    if ((tokens.accessToken !== null && hasTokenExpired(tokens.accessToken)) || forceRefresh) {
        yield put({ type: 'USER_LOGIN_PENDING' });

        // Redirect user to the login page if no refresh token exists
        if (tokens.refreshToken === null) {
            yield put({ type: 'USER_LOGIN_FAILED' });
            yield put({ type: 'CHECK_TOKENS_COMPLETE', silent: true });

            const currentRoute = yield select(getCurrentRoute);
            if (currentRoute !== '/login') {
                yield put(replace('/login'));
            }

            return;
        }

        // Call the endpoint
        const hubRequest = yield call(refreshAuthentication, tokens.refreshToken);

        if (hubRequest.error) {
            yield put({ type: 'CHECK_TOKENS_COMPLETE', silent: true });
            yield put({ type: 'DELETE_TOKENS' });
            yield put({ type: 'USER_LOGIN_FAILED' });

            // Re-direct user to the login page
            yield put(replace('/login'));
        } else {
            yield put({
                type: 'SET_TOKENS',
                accessToken: hubRequest.message.data.access_token,
                refreshToken: hubRequest.message.data.refresh_token,
            });

            // Mark the login as success
            yield put({ type: 'USER_LOGIN_SUCCESS' });
            yield put({ type: 'CHECK_TOKENS_COMPLETE', silent: true });

            // Re-direct the user to the dashboard, if the user is logging in automatically
            const currentRoute = yield select(getCurrentRoute);
            if (currentRoute === '/login' || currentRoute === '/') {
                yield put(replace('/companies/'));
            }
        }
    } else {
        // Tokens have not expired, continue as normal
        yield put({ type: 'CHECK_TOKENS_COMPLETE', silent: true });

        // Re-direct the user to the dashboard, if the user is logging in automatically
        const currentRoute = yield select(getCurrentRoute);
        if (currentRoute === '/login' || currentRoute === '/') {
            yield put(replace('/companies/'));
        }
    }
}
